<template>
  <div class="wrap-bg">
    <div class="section-gap info">
      <div class="container">
        <div class="section-title-wrapper extra-p">
          <div class="fullscreen-row splash-s splash-container extra-p">
            <div class="col-sm-12 mx-auto text-center splash-container d-flex">
              <h1 class="h1-larger">Preise</h1>
            </div>
          </div>
        </div>
        <div class="row d-flex">
          <div
            class="col-sm-12 col-md-4 col-lg-4 text-center"
            data-aos="zoom-in-down"
            data-aos-duration="1000"
            v-for="(item,i) of items1.array"
            :key="i"
          >
            <div class="main-section">
              <div class="row">
                <div
                  class="col-lg-12 col-sm-12 col-12 user-detail"
                  @mouseover="hover = i"
                  @mouseleave="hover = 10"
                >
                  <img v-if="hover == i" :src="item.image_orange" class="img-thumbnail" />
                  <img v-else :src="item.image_white" class="img-thumbnail" />
                  <div class="col-lg-12 text-content" v-if="render_first && render_second && render_third">
                    <div style="padding-top: 30px">
                      <h2>{{item.title}}</h2>
                      <vm
                        id="vm"
                        class="mb-0 white lead p-info vm"
                      >{{ prices[i].fields.description }}</vm>
                      <!-- <p class="pre-formatted">{{item.text}}</p> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import client from "@/utils/api.js";
import VueMarkdown from "vue-markdown";

export default {
  name: "Prices",
  data() {
    return {
      prices: [],
      render_first: false,
      render_second: false,
      render_third: false,
      hover: 10,
      items1: {
        array: [
          {
            image_white: "/static/img/icons/White/cup_white.png",
            image_orange: "/static/img/icons/Orange/cup_orange.png",
            title: "1. Platz",
          },
          {
            image_white: "/static/img/icons/White/cup_2_white.png",
            image_orange: "/static/img/icons/Orange/cup_2_orange.png",
            title: "2. Platz",
          },
          {
            image_white: "/static/img/icons/White/cup_3_white.png",
            image_orange: "/static/img/icons/Orange/cup_3_orange.png",
            title: "3. Platz",
          },
        ],
      },
    };
  },
  components: {
    vm: VueMarkdown,
  },
  created() {
    //Get Grundinfo
    client.getEntry("2Oa3GCSDf2DokSzE8qPj3j").then((response) => {
      this.prices[0] = response;
      this.render_first = true;
    });

    client.getEntry("34BHySairSdNO5ryRPPIXO").then((response) => {
      this.prices[1] = response;
      this.render_second = true;
    });

    client.getEntry("34wxfi5WbEChg6HRtKLM5T").then((response) => {
      this.prices[2] = response;
      this.render_third = true;
    });
  },
};
</script>
<style scoped>
.extra-p {
  padding-bottom: 50px;
}

.vm {
  padding-top: 20px;
}
.wrap-bg {
  background: url(/static/img/background_muster_10.png);
  background-position: 100% 100%;
  background-size: cover;
  background-attachment: fixed;
}
@media (hover: none) {
  .wrap-bg {
    background-attachment: initial !important;
    background-position: center !important;
  }
}

.info {
  /* background-color: black; */
}
.main-section {
  background: linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.9)),
    linear-gradient(white, white);
  margin-bottom: 30%;
}

.pre-formatted {
  white-space: pre;
}

.text-content {
  height: 100%;
}
/* ul {
  list-style-type: '- ' !important;
}
#vm {
  list-style-type:lower-roman !imporant;
} */
.user-detail {
  margin: -40px 0px 30px 0px;
  height: 400px;
}
.user-detail img {
  height: 30%;
  background-color: transparent;
  border: none;
}
.user-detail h5 {
  margin: 15px 0px 5px 0px;
}

.extra-p {
  padding-top: 30px;
}

.splash-s {
  background-image: url(/static/img/splash_qualifier_red.png);
  background-position: 62% 10%;
  background-repeat: no-repeat;
  /* width: 100%; */
  min-height: 120px;
}
.splash-container {
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 760px) {
  .splash-s {
    background-image: url(/static/img/splash_qualifier_red.png);
    background-position: 80% 10%;
    background-repeat: no-repeat;
    background-size: 100px;
    min-height: 200px;
  }
}

@media screen and (min-width: 761px) and (max-width: 1000px) {
  .splash-s {
    background-image: url(/static/img/splash_qualifier_red.png);
    background-position: 62% 20%;
    background-repeat: no-repeat;
    background-size: 100px;
    min-height: 200px;
  }
}
</style>

